import React from 'react';

/** Bento-grid dashboard icon (layout matches provided asset; color via currentColor). */
export default function PersonalHubDashboardIcon({ className = '' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="3" y="3" width="7.5" height="7.5" rx="2" fill="currentColor" />
      <rect x="3" y="12.5" width="7.5" height="8.5" rx="2" fill="currentColor" />
      <rect x="12.5" y="3" width="8.5" height="10.5" rx="2" fill="currentColor" />
      <rect x="12.5" y="15.5" width="8.5" height="5.5" rx="2" fill="currentColor" />
    </svg>
  );
}
